const PRODUCT_DATA = `
    id
    title
    vendor
    handle
    description
    descriptionHtml
    images(first: 200) {
        edges {
            node {
                id
                url
                altText
            }
        }
    }
    metafield(namespace: "custom", key: "exclusive") {
        key
        value
    }
	certificates: metafield(namespace: "custom", key: "require_certificates_and_membership_cards_fields") {
		key
		value
	}
    organization_lca: metafield(namespace: "custom", key: "organization_lca") {
        value
    }
    organization_pdt: metafield(namespace: "custom", key: "organization_pdt") {
        value
    }
    organization_agd: metafield(namespace: "custom", key: "organization_agd") {
        value
    }
    sellingPlanGroups(first: 1) {
        edges {
            node {
                name
            }
        }
    }
    options {
        id
        name
        optionValues {
            id
            name
            swatch {
                color
                image {
                    alt
                    id
                    mediaContentType
                    previewImage {
                        altText
                        url
                    }
                }
            }
        }
    }
    availableForSale
    featuredImage {
        altText
        url
        height
        width
    }
    tags
    variants (first: 250) {
        edges {
            node {
                id
                image {
                    url
                }
                price {
                    amount
                    currencyCode
                }
                compareAtPrice {
                    amount
                    currencyCode
                }
                components(first: 100) {
                    edges {
                      node {
                        productVariant {
                          id
                          title
                          sku
                          price {
                            amount
                            currencyCode
                          }
                          product {
                            id
                            title
                          }
                        }
                        quantity
                      }
                    }
                  }
                quantityAvailable
                title
                availableForSale
                selectedOptions {
                    name
                    value
                }
                sku
                metafields(identifiers: [
                    {namespace: "custom", key: "details"}
                    {namespace: "custom", key: "materials"}
                    {namespace: "custom", key: "shipping_and_returns"}
                ]) {
                    id
                    value
                    type
                    description
                    namespace
                    key
                    value
                }
            }
        }
    }
`;

const PRODUCT_BASIC_DATA = `
    id
    title
    vendor
    handle
    description
    descriptionHtml
    images(first: 200) {
        edges {
            node {
                id
                url
                altText
            }
        }
    }
    metafield(namespace: "custom", key: "exclusive") {
        key
        value
    }
	certificates: metafield(namespace: "custom", key: "require_certificates_and_membership_cards_fields") {
		key
		value
	}
    organization_lca: metafield(namespace: "custom", key: "organization_lca") {
        value
    }
    organization_pdt: metafield(namespace: "custom", key: "organization_pdt") {
        value
    }
    organization_agd: metafield(namespace: "custom", key: "organization_agd") {
        value
    }
    sellingPlanGroups(first: 1) {
        edges {
            node {
                name
            }
        }
    }
    options {
        id
        name
        optionValues {
            id
            name
            swatch {
                color
                image {
                    alt
                    id
                    mediaContentType
                    previewImage {
                        altText
                        url
                    }
                }
            }
        }
    }
    availableForSale
    featuredImage {
        altText
        url
        height
        width
    }
    tags
    variants (first: 250) {
        edges {
            node {
                id
                image {
                    url
                }
                price {
                    amount
                    currencyCode
                }
                compareAtPrice {
                    amount
                    currencyCode
                }
                components(first: 1) {
                    edges {
                      node {
                        productVariant {
                          id
                          title
                          sku
                          price {
                            amount
                            currencyCode
                          }
                          product {
                            id
                            title
                          }
                        }
                        quantity
                      }
                    }
                  }
                quantityAvailable
                title
                availableForSale
                selectedOptions {
                    name
                    value
                }
                sku
                metafields(identifiers: [
                    {namespace: "custom", key: "details"}
                    {namespace: "custom", key: "materials"}
                    {namespace: "custom", key: "shipping_and_returns"}
                ]) {
                    id
                    value
                    type
                    description
                    namespace
                    key
                    value
                }
            }
        }
    }
`;

export const PRODUCT_DETAILED_DATA =
  `
    ` +
  PRODUCT_DATA +
  `
    collections(first: $collectionNumber) {
        edges {
            node {
                id
                title,
                handle
            }
        }
    }
`;

export const PRODUCT_COLLECTION_DATA =
  `
    ` +
  PRODUCT_BASIC_DATA +
  `
    collections(first: $collectionNumber) {
        edges {
            node {
                id
                title
            }
        }
    }
`;

export const PRODUCT_DETAILED_CART_DATA =
  `
    ` +
  PRODUCT_DATA +
  `
    collections(first: 10) {
        edges {
            node {
                id
                title
            }
        }
    }
`;

export const PRODUCT_DETAILS_QUERY =
  `
query GetProductDetails($handle: String!, $collectionNumber: Int = 250) {
    product(handle: $handle) {
        ` +
  PRODUCT_DETAILED_DATA +
  `
    }
}`;

export const META_OBJECT = `
query getMetaObject($type: String!) {
    metaobjects(type: $type, first: 250) {
        edges {
            node {
                handle
                id
                type
                fields {
                    key
                    type
                    value
                }
            }
        }
    }
}`;

export const VARIANTS_QUERY = `
query getVariants($ids: [ID!]!) {
	nodes(ids: $ids) {
		... on ProductVariant {
		    id
		    quantityAvailable
            availableForSale
            title
            image {
                altText
                url
                height
                width
            }
            price {
                amount
                currencyCode
            }
            selectedOptions {
                name
                value
            }
            compareAtPrice {
                amount
                currencyCode
            }
            product {
                id
                title
                handle
            }
        }
	}
}`;

export const RELATED_PRODUCTS =
  `
query getComplementaryProductRecommendations(
    $productId: ID!
    $intent: ProductRecommendationIntent!
    $collectionNumber: Int = 10
) {
    productRecommendations(productId: $productId, intent: $intent) {
        ` +
  PRODUCT_DETAILED_DATA +
  `
    }
}`;

export const PRODUCTS_BY_IDS =
  `
query getProducts($ids: [ID!]!, $collectionNumber: Int = 10) {
	nodes(ids: $ids) {
    ...on Product {
      ` +
  PRODUCT_DETAILED_DATA +
  `
    }
  }
}`;

export const PRODUCT_VARIANTS_PAGINATED_QUERY = `
query GetProductVariantsPaginated($handle: String!, $first: Int!, $after: String) {
    product(handle: $handle) {
        id
        title
        handle
        variants(first: $first, after: $after) {
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
            edges {
                cursor
                node {
                    id
                    image {
                        url
                    }
                    price {
                        amount
                        currencyCode
                    }
                    compareAtPrice {
                        amount
                        currencyCode
                    }
                    components(first: 100) {
                        edges {
                          node {
                            productVariant {
                              id
                              title
                              sku
                              price {
                                amount
                                currencyCode
                              }
                              product {
                                id
                                title
                              }
                            }
                            quantity
                          }
                        }
                      }
                    quantityAvailable
                    title
                    availableForSale
                    selectedOptions {
                        name
                        value
                    }
                    sku
                    color: metafield(namespace: "custom", key: "color_keyword") {
                        key
                        value
                        type
                    }
                    metafields(identifiers: [
                        {namespace: "custom", key: "color"}
                        {namespace: "custom", key: "details"}
                        {namespace: "custom", key: "materials"}
                        {namespace: "custom", key: "shipping_and_returns"}
                    ]) {
                        id
                        value
                        type
                        description
                        namespace
                        key
                        value
                    }
                }
            }
        }
    }
}`;
